import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';
import { kioskCartFunnelBottomPaddingProperty } from './kiosk-cart-funnel-top-padding';

export const CARTFUNNELPAGE_LEGACY_FIELD_ORDER = [
  'background_color',
  'background_image',
  'bottom_padding',
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartFunnelPageDescriptor: _generatedCartFunnelPageDescriptor,
  cartFunnelPageBlocDefinition,
  cartFunnelPageDashboardLayout,
  cartFunnelPageConfig,
  cartFunnelPageResolveConfig,
  cartFunnelPageProperties,
} = doodBlockConfig(
  {
    name: "Cart funnel page",
    internal_name: "Cart funnel page",
    url: "cart/funnel",
    defaultParent: [/^Main Layout$/i],
    componentType: 'CartFunnelPageComponent',
    category: 'page',
    description: "Cart funnel page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'header',
        name: "pages.blocks.cart-funnel-page.header.label",
        accept: 'explicitOnly',
        allowedTypes: ["CartFunnelHeaderBlock"],
        slotItemFormat: 'ids',
      },
      {
        key: 'content',
        name: "pages.blocks.cart-funnel-page.content.label",
        accept: 'explicitOnly',
        allowedTypes: ["TextBlock", "FrameBlock", "ImageFullWidthBlock", "ImageVariableWidthBlock", "ImageAndTextBlock"],
        slotItemFormat: 'ids',
      },
      {
        key: 'body',
        name: "pages.blocks.cart-funnel-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: ["CartFunnelFormBlock"],
        slotItemFormat: 'ids',
      },
      {
        key: 'bottom_content',
        name: "pages.blocks.cart-funnel-page.bottom-content.label",
        accept: 'explicitOnly',
        allowedTypes: ["TextBlock", "FrameBlock", "ImageFullWidthBlock", "ImageVariableWidthBlock", "ImageAndTextBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: { type: 'hex', value: '#FFFFFF' },
      options: {
        label: 'pages.blocks.cart-funnel-page.background-color.label',
      },
    }),
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: 'pages.blocks.cart-funnel-page.background-image.label',
        help: 'pages.blocks.cart-funnel-page.background-image.help',
      },
    }),
    bottom_padding: kioskCartFunnelBottomPaddingProperty('cart-funnel-page'),
  }),

  () => ({
    tabs: [
      {
        label: 'pages.blocks.cart-funnel-page.tab.design.label',
        fieldsets: [
          {
            legend: 'pages.blocks.cart-funnel-page.fieldset.content.label',
            fields: ["header", "content", "body", "bottom_content", "bottom_padding", "background_color", "background_image"],
          },
        ],
      },
    ],
  })
);

export function cartFunnelPageDescriptor(): IBlockDescriptor;
export function cartFunnelPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartFunnelPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartFunnelPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartFunnelPageDescriptor, cartFunnelPageProperties, fieldOrder);
}

export {
  cartFunnelPageBlocDefinition,
  cartFunnelPageDashboardLayout,
  cartFunnelPageProperties,
  cartFunnelPageConfig,
  cartFunnelPageResolveConfig,
};

export type CartFunnelPageConfig = typeof cartFunnelPageConfig;
